import { useSearchStore } from '@stores/search.store'

import React, { Fragment, Suspense } from 'react'

import { JobItem as JobItemType } from '@types'

import { useShallow } from 'zustand/react/shallow'

import JobCard from '@components/job-card'

type PageProps = {
  items: JobItemType[]
  page: number
}

const ResultsPage = ({ items, page }: PageProps): JSX.Element | null => {
  const [search, setSerpPositionClicked, setScrollPosition] = useSearchStore(
    useShallow((state) => [state.search, state.setSerpPositionClicked, state.setScrollPosition]),
  )

  const onJobItemClick = (position: number): void => {
    setSerpPositionClicked((search.page - 1) * Number(process.env.NEXT_PUBLIC_SERP_PAGE_SIZE || '5') + (position + 1))
    setScrollPosition(window.scrollY)
  }

  return (
    <div data-page={page}>
      {items.map((job, i) => (
        <Fragment key={`job-id-${job?.id}`}>
          <Suspense>
            <JobCard
              key={`job-id-${job?.id}`}
              job={job}
              dataCy={i === 0 && page === 1 ? 'serp-job-item' : undefined}
              onClick={(): void => onJobItemClick(i)}
            />
          </Suspense>
        </Fragment>
      ))}
    </div>
  )
}

export default ResultsPage
